<script lang="ts">
  import Skeleton from "svelte-skeleton/Skeleton.svelte";
  import KevelBanner from "@shared/svelte/Components/Banner/KevelBanner.svelte";
  import { getExternalBanner } from "@shared/services/banner_service";

  export let mobileMode: boolean = false;
  export let pageName: string;
  export let pageValue: string | null = null;
  mobileMode;

  let loaded: boolean = false;

  let banners;
  getExternalBanner(pageName, pageValue, {}).then(res => {
    loaded = true;
    banners = res[0][0].banners;
  });

  $: innerWidth = 0;
  $: mobileModeBanner = innerWidth < 480;

  $: skeletonHeight = mobileModeBanner ? 85 : 150;
  $: skeletonWidth = mobileModeBanner ? 390 : 1300;
</script>

<svelte:window bind:innerWidth />
<div class="fizz-styles" data-testid="kevel-banner">
  {#if !loaded}
    <div class="fizz-grid-center fizz-stack-24">
      <Skeleton animate={true} height={skeletonHeight} width={skeletonWidth} />
    </div>
  {:else if banners && banners.length > 0}
    <KevelBanner {banners} {mobileMode} {pageName} />
  {/if}
</div>
